module.exports = __webpack_public_path__ + "static/media/fix_cash30.7863c640.png";